import React from 'react'
import Small from '../helpers/small'

import Header from './header'
import Content from './content'
import Footer from './footer'

export default function SplitViewMain({ children, className = '', ...other }) {
    return (
        <Small
            as='main'
            className={'svMain ' + className}
            minWidth={600}
            {...other}>
            {children}
        </Small>
    )
}

export {
    Header,
    Content,
    Footer,
}
